<template>
  <div class="login-page">
    <div class="login-card">
      <h1 class="title">南京捷奥</h1>
      <p class="subtitle">个人生活记录</p>
      <a-form :form="form" @submit.prevent="handleSubmit">
        <a-form-item>
          <a-input
            v-decorator="['username', { rules: [{ required: true, message: '请输入用户名' }] }]"
            size="large"
            placeholder="用户名"
            allow-clear
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-password
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
            size="large"
            placeholder="密码"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input-password>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" size="large" block :loading="loading">
            登录
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { login } from '../api/auth'
import { setToken, setUsername } from '../utils/auth'

export default {
  name: 'Login',
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (err) return
        this.loading = true
        try {
          const res = await login(values.username, values.password)
          setToken(res.data.token)
          setUsername(res.data.username || values.username)
          this.$message.success('登录成功')
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)
        } catch (e) {
          // 拦截器已提示
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  width: 380px;
  background: #fff;
  padding: 36px 32px 24px;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
}
.title {
  margin: 0;
  text-align: center;
  font-size: 28px;
}
.subtitle {
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  margin: 8px 0 28px;
}
</style>
